import { ICounter } from "./types";
import Heatmap from "../../ReportsAndStatistics/Energy/Heatmap/Heatmap";
import { TimeRange } from "../../../utils/timeUtils";
import { LabelMedium } from "baseui/typography";
import { FormattedMessage } from "react-intl";
import { Block } from "baseui/block";
import { useStyletron } from "baseui";
import { CounterMedium } from "../CounterMedium";


const InsightsPanel = (props: ICounter) => {
    const [,theme] = useStyletron();
    const range = TimeRange.YearToDate;

    const colors = props.counterMedium === CounterMedium.WaterMeter ? getWaterColors(theme) : undefined

    return (<>
      <Block gridGap={'20px'} display={'flex'} flexDirection={'column'}>
        <LabelMedium>
            <FormattedMessage id={TimeRange[range]} defaultMessage={TimeRange[range]} /> | {props.dimension}
        </LabelMedium>
        <Heatmap colors={colors}  timeRange={range} mediumFilter={[]} typeFilter={[]} {...props} />
        </Block>
    </>)
}

export default InsightsPanel


const getWaterColors = (theme) => {
    return [
        theme.colors.accent100,
        theme.colors.accent400,
        theme.colors.warning100,
        theme.colors.warning400,
        theme.colors.negative100,
        theme.colors.negative400,
    ]
}